import BaseComponent from "../../baseComponent.js";
import styles from "../../common/tab.scss";

export default class CurrentTab extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.tab ? this.props.tab.title : ""
    }
  }

  componentDidMount() {
    let _this = this;
    this.isEditMode = false;
    if (!isMobile()) {
      $(this.refs.tab).hover(function () {
        if (!_this.isEditMode) {
          $(_this.refs.actions).stop().fadeIn(200);
        }
      }, function () {
        $(_this.refs.actions).stop().fadeOut(200);
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      title: nextProps.tab.title
    });
  }

  render() {
    return (
      <div className={styles.currentTab} ref="tab" style={{margin: 0}}>
        <div className={styles.title} ref="title">{this.state.title}</div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/profile/tab/currentTab.jsx